
















































































































/* General */
import Vue from 'vue'
import MailboxVerificationLayout from '@/layouts/mailbox-verification-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import MailboxVerificationInstructionsGoogleBusiness from './components/mailbox-verification-instructions-google-business.vue'
import MailboxVerificationInstructionsMicrosoft from './components/mailbox-verification-instructions-microsoft.vue'
import MailboxVerificationInstructionsRackspace from './components/mailbox-verification-instructions-rackspace.vue'
import MailboxVerificationInstructionsZoho from './components/mailbox-verification-instructions-zoho.vue'
import MailboxVerificationInstructionsYahoo from './components/mailbox-verification-instructions-yahoo.vue'
import MailboxVerificationInstructionsGoDaddy from './components/mailbox-verification-instructions-go-daddy.vue'
import MailboxVerificationInstructionsCpanel from './components/mailbox-verification-instructions-cpanel.vue'
import MailboxVerificationInstructionsNoProvider from './components/mailbox-verification-instructions-no-provider.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */
import { IMailboxesOutputAutoForwarding } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  metaInfo: {
    title: 'Verify Auto-Forwarding Address',
  },

  components: {
    MailboxVerificationLayout,
    EntitySettingsLoading,
    MailboxVerificationInstructionsGoogleBusiness,
    MailboxVerificationInstructionsMicrosoft,
    MailboxVerificationInstructionsRackspace,
    MailboxVerificationInstructionsZoho,
    MailboxVerificationInstructionsYahoo,
    MailboxVerificationInstructionsGoDaddy,
    MailboxVerificationInstructionsCpanel,
    MailboxVerificationInstructionsNoProvider,
  },

  data() {
    return {
      RouteAssistant,
      LocalStore,
      mailboxName: '',
      isLoading: true,
      isSubmitting: false,
      showVerificationPopup: false,
      emailProvider: null,
      autoForwardingSettings: {} as IMailboxesOutputAutoForwarding,
    }
  },

  computed: {
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    title(): string {
      return `Auto-forward from ${this.forwardingFromAddress}`
    },
    forwardingFromAddress(): string {
      return LocalStore.mailboxForwardingAddressCandidate
    },
  },

  async created() {
    this.isLoading = true
    await this.getAutoForwardingInfo()
    if (!this.forwardingFromAddress) {
      RouteAssistant.goToMailboxVerificationIntroRoute(
        this.$router,
        this.accountID,
        this.mailboxID,
      )
    }
    this.isLoading = false
  },

  methods: {
    async getAutoForwardingInfo() {
      try {
        this.autoForwardingSettings = await MailboxesAPI.get_AutoForwarding(
          this.mailboxID,
        )
        this.mailboxName = this.autoForwardingSettings.name
      } catch (err) {
        this.$error.emit(err)
      }
    },
    async goToAutoForwardingTest() {
      RouteAssistant.goToMailboxVerificationAutoForwardingTestingRoute(
        this.$router,
        this.accountID,
        this.mailboxID,
      )
    },
  },
})
